module.exports = __webpack_public_path__ + "img/admin-menu-item.5e60161e.png";